import { checkAndSetGermanDateFormat, checkAndSetUSFormat } from './dateFormat';

export const getObjectSize = (obj) => Object.keys(obj).length;

export const getInitialValuesFormular = (dataContent) => {
  const initialValues = {};

  const buildInitialValues = (obj, prefix = '') => {
    for (const key in obj) {
      if (obj[key] !== null && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        buildInitialValues(obj[key], `${prefix}${key}__`);
      } else if (Array.isArray(obj[key])) {
        if (obj[key].every((item) => typeof item === 'string')) {
          initialValues[`${prefix}${key}`] = obj[key];
        } else {
          obj[key].forEach((item) => {
            if (typeof item === 'object') {
              buildInitialValues(item, `${prefix}${key}__${item.id}__`);
            } else {
              initialValues[`${prefix}${key}__${item.id}`] =
                checkAndSetGermanDateFormat(item);
            }
          });
        }
      } else {
        initialValues[`${prefix}${key}`] = checkAndSetGermanDateFormat(obj[key]);
      }
    }
  };

  buildInitialValues(dataContent);
  return initialValues;
};

export const changeMultiSelectValues = (initValues, value, checked) => {
  if (checked === false) return initValues.filter((item) => item !== value);
  if (!initValues) return [value];
  if (!initValues.includes(value)) return [...initValues, value];
  return initValues;
};

export const updateDataContent = (inputName, inputValue, data, updateAction) => {
  const parts = inputName.split('__');
  let current = data;
  let currentItemID;

  for (let i = 0; i < parts.length - 1; i++) {
    const part = parts[i];
    if (current[part] && isNaN(part)) {
      current = current[part];
    } else {
      currentItemID = part;
    }
  }

  const propertyName = parts[parts.length - 1];

  if (updateAction === 'deleteComponent') {
    const pathSegments = inputName.split('.');
    for (const segment of pathSegments) {
      if (Object.prototype.hasOwnProperty.call(current, segment)) {
        current = current[segment];
      }
    }
    if (Array.isArray(current)) current.splice(inputValue, 1);
  } else if (updateAction === 'updateByID') {
    if (currentItemID === 'undefined') {
      const newObj = {};
      newObj[propertyName] = inputValue;
      current.push(newObj);
    } else {
      const itemToUpdate = current.find((item) => item.id == currentItemID);
      if (itemToUpdate) {
        itemToUpdate[propertyName] = checkAndSetUSFormat(inputValue);
      }
    }
  } else {
    current[propertyName] = checkAndSetUSFormat(inputValue);
  }

  return { ...data };
};

export const locationSearch = (autocompleteService, value, setLocationOptions) => {
  if (!autocompleteService) return;
  autocompleteService.getPlacePredictions(
    { input: value, region: 'de-DE' },
    (predictions, status) => {
      setLocationOptions(status === 'OK' ? predictions : []);
    }
  );
};

export const addIcon = (fieldId) => {
  const el = document.getElementById(fieldId);
  if (el) {
    el.classList.add('with-icon');
    el.innerHTML += `<span class="save-icon"><i class="save-icon-inner"></i></span>`;
  }
};

export const setInitialUploadForms = (
  updatedUploadForms,
  files,
  name,
  singleComponent = false
) => {
  updatedUploadForms[name] = {};

  if (singleComponent) {
    updatedUploadForms[name] =
      files && files !== '-'
        ? { file: files, visible: false }
        : { file: '', visible: true };
  } else {
    for (const key in files) {
      if (Object.prototype.hasOwnProperty.call(files, key)) {
        const file = files[key];
        let fileContainer = null;
        for (const keyFile in file) {
          if (
            Object.prototype.hasOwnProperty.call(file, keyFile) &&
            typeof file[keyFile] === 'object' &&
            file[keyFile] !== null
          ) {
            fileContainer = file[keyFile];
          }
        }
        updatedUploadForms[name][file.id] = {
          file: fileContainer ?? '',
          visible: !fileContainer,
        };
      }
    }
  }

  return updatedUploadForms;
};
